import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13a3460a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ss-tela-titulo" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Personalizações de Telas")
    ])
  ])
], -1))
const _hoisted_5 = { class: "ss-tela-conteudo" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-5 ant-col-xl-5 ss-display-flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-texto" }, "Empresa", -1))
const _hoisted_9 = { class: "ss-texto grande" }
const _hoisted_10 = { class: "ant-col ant-col-xs-15 ant-col-xl-15 ss-separador-p10 ss-display-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-texto" }, "Tela", -1))
const _hoisted_12 = { class: "ss-texto grande" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4 ss-separador-p10" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ss-card ss-card-space" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"center","font-size":"26px"} }, "Personalizar nova tela", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_personalizacao_tela_modal = _resolveComponent("personalizacao-tela-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaPersonalizacoes, (personalizacao) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ss-card ss-card-space",
                key: personalizacao.codigo
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _hoisted_8,
                      _createElementVNode("span", _hoisted_9, _toDisplayString(personalizacao.nomeExibicaoEmpresa), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _hoisted_11,
                      _createElementVNode("span", _hoisted_12, _toDisplayString(personalizacao.descricaoRecurso), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-secondary ss-margin-botoes horizontal ss-btn-acao-destaque",
                        style: {"float":"left"},
                        onClick: ($event: any) => (_ctx.editar(personalizacao.codigo))
                      }, "Editar", 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-secondary ss-margin-botoes horizontal ss-btn-acao-destaque",
                        style: {"float":"right"},
                        onClick: ($event: any) => (_ctx.excluir(personalizacao.codigo, personalizacao.descricaoRecurso))
                      }, "Excluir", 8, _hoisted_17)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-block",
                    style: {"min-height":"60px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editar(0)))
                  }, [
                    _createVNode(_component_icone, {
                      style: {"font-size":"20px","margin-right":"10px"},
                      nome: "novo"
                    }),
                    _hoisted_21
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_personalizacao_tela_modal, {
      visivel: _ctx.state.exibirEditarPersonalizacao,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirEditarPersonalizacao) = $event)),
      operacao: _ctx.state.edicaoPersonalizacao,
      "onUpdate:operacao": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.edicaoPersonalizacao) = $event)),
      onConfirmacao: _ctx.confirmarEdicao
    }, null, 8, ["visivel", "operacao", "onConfirmacao"])
  ], 64))
}